import { render, staticRenderFns } from "./gateway-header.vue?vue&type=template&id=1b8f4482&scoped=true"
import script from "./gateway-header.vue?vue&type=script&lang=js"
export * from "./gateway-header.vue?vue&type=script&lang=js"
import style0 from "./gateway-header.vue?vue&type=style&index=0&id=1b8f4482&prod&lang=less&scoped=true"
import style1 from "./gateway-header.vue?vue&type=style&index=1&id=1b8f4482&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f4482",
  null
  
)

export default component.exports